export default "__VITE_ASSET__DXf1gnoI__"